import { render, staticRenderFns } from "./user-info-configuration.vue?vue&type=template&id=55c73676&scoped=true"
import script from "./user-info-configuration.vue?vue&type=script&lang=js"
export * from "./user-info-configuration.vue?vue&type=script&lang=js"
import style0 from "./user-info-configuration.vue?vue&type=style&index=0&id=55c73676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c73676",
  null
  
)

export default component.exports